import React from 'react';

const CopyRightRule = () => {
    return (
        <div className='mt-14 mb-14 flex flex-col gap-5 ml-24 mr-24'>
            <div>올댓 마라톤은 온라인상에서 개인정보호를 소중히 생각합니다.</div>
            
                <li>개인정보보호정책이란 올댓 마라톤 서비스를 이용한 회원님들의 권익을 보호하여 사용자들이 안심하고 서비스를 받으실 수 있도록 본사가 준수해야할지침을 말합니다.</li>
                <li>올댓 마라톤의 보호정책은 [정보통신망이용촉진등에 관한 법률]상의 개인정보보호 규정 및 정보통신부가 제정한 [개인정보보호지침]을 준수합니다.</li>
                <li>본 보호정책은 관련법률 및 정부지침의 변경과 본사 내부 방침의 변경에 의해 주시로 변경 될수 있으므로 자주 확인하시기 바랍니다.</li>
            
            <div>제1조(목적)</div>
            <div>이 약관은 전기통신사업법령 및 정보통신망이용촉진등에 관한 법령에 의하여 올댓 마라톤(이하 "회사"라 합니다)가 운영하는 marazone.co.kr(마라존) 등 인터넷 서비스 (이하 “서비스"라 한다)의 이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.</div>
            <div>제2조(약관의 효력 및 변경)</div>
            <div>(1) 이 약관은 회사가 그 내용을 서비스 화면을 통해 게시하고 이용자가 이에 동의를 함으로써 효력을 발생합니다.</div>
            <div>(2) 회사는 합리적인 사유가 있을 경우 약관규제에 관한 법률, 정보통신망 이용촉진 및 정보보호등에 관한 법률 등 관련법을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 이 경우 적용일자 및 개정사유를 명시하여 현행약관과 함께 마라존의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.</div>
            <div>제3조(개인정보의 제공 및 위탁)</div>
            <div>회사는 원칙적으로 이용자 동의 없이 개인정보를 외부에 제공하지 않습니다.</div>
            <div>단, 관련 법령에 의거해 마라존에 개인정보 제출 의무가 발생한 경우, 이용자의 생명이나 안전에 급박한 위험이 확인되어 이를 해소하기 위한 경우에 한하여 개인정보를 제공하고 있습니다.</div>
        </div>
    );
};

export default CopyRightRule;